/**
 * Funding archive – client-side filter logic, modal & deep-link via query string.
 */
document.addEventListener('DOMContentLoaded', function () {
  /* ── Filter dropdowns ──────────────────────────────────────────────── */
  var catSelect = document.getElementById('funding-filter-category');
  var typeSelect = document.getElementById('funding-filter-type');
  var recipientSelect = document.getElementById('funding-filter-recipient');
  var cards = Array.prototype.slice.call(document.querySelectorAll('.funding-card'));
  var noResults = document.querySelector('.funding-no-results');

  if (catSelect && typeSelect && recipientSelect) {
    function filterCards() {
      var cat = catSelect.value || 'all';
      var type = typeSelect.value || 'all';
      var recipient = recipientSelect.value || 'all';
      var visible = 0;

      cards.forEach(function (card) {
        var cardCats = (card.getAttribute('data-category') || '').split(' ').filter(Boolean);
        var cardTypes = (card.getAttribute('data-type') || '').split(' ').filter(Boolean);
        var cardRecipients = (card.getAttribute('data-recipient') || '').split(' ').filter(Boolean);

        var catMatch = cat === 'all' || cardCats.indexOf(cat) !== -1;
        var typeMatch = type === 'all' || cardTypes.indexOf(type) !== -1;
        var recipientMatch = recipient === 'all' || cardRecipients.indexOf(recipient) !== -1;

        var show = catMatch && typeMatch && recipientMatch;
        card.style.display = show ? '' : 'none';
        if (show) visible++;
      });

      if (noResults) {
        noResults.style.display = visible === 0 ? '' : 'none';
      }
    }

    catSelect.addEventListener('change', filterCards);
    typeSelect.addEventListener('change', filterCards);
    recipientSelect.addEventListener('change', filterCards);
    filterCards();
  }

  /* ── Query-string helpers ──────────────────────────────────────────── */
  var PARAM = 'funding_post';

  function getSlugFromURL() {
    var params = new URLSearchParams(window.location.search);
    return params.get(PARAM) || '';
  }

  function setSlugInURL(slug) {
    var url = new URL(window.location);
    if (slug) {
      url.searchParams.set(PARAM, slug);
    } else {
      url.searchParams.delete(PARAM);
    }
    history.replaceState(null, '', url);
  }

  function findCardBySlug(slug) {
    if (!slug) return null;
    for (var i = 0; i < cards.length; i++) {
      if (cards[i].getAttribute('data-slug') === slug) return cards[i];
    }
    return null;
  }

  /* ── Modal ─────────────────────────────────────────────────────────── */
  var modal = document.getElementById('funding-modal');
  if (!modal) return;

  var modalBody = modal.querySelector('.funding-modal__body');
  var closeBtn = modal.querySelector('.funding-modal__close');

  function openModal(card) {
    var source = card.querySelector('.funding-modal-data');
    if (!source) return;
    var slug = card.getAttribute('data-slug') || '';
    modalBody.innerHTML = source.innerHTML;
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    setSlugInURL(slug);
    if (closeBtn) closeBtn.focus();
  }

  function closeModal() {
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    modalBody.innerHTML = '';
    document.body.style.overflow = '';
    setSlugInURL('');
  }

  function highlightCard(card) {
    card.classList.add('funding-card--highlight');
    if (window.innerWidth > 1024) {
      var top = card.getBoundingClientRect().top + window.pageYOffset - 88;
      window.scrollTo({ top: top, behavior: 'smooth' });
    } else {
      card.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }

  // Delegate clicks on modal-trigger buttons
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-funding-modal]');
    if (trigger) {
      e.preventDefault();
      var card = trigger.closest('.funding-card');
      if (card) openModal(card);
      return;
    }
  });

  // Close via × button
  if (closeBtn) {
    closeBtn.addEventListener('click', closeModal);
  }

  // Close when clicking overlay backdrop
  modal.addEventListener('click', function (e) {
    if (e.target === modal) closeModal();
  });

  // Close on Escape key
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && modal.classList.contains('is-open')) {
      closeModal();
    }
  });

  /* ── Deep-link on page load ────────────────────────────────────────── */
  var initialSlug = getSlugFromURL();
  if (initialSlug) {
    var targetCard = findCardBySlug(initialSlug);
    if (targetCard) {
      var hasModal = !!targetCard.querySelector('.funding-modal-data');
      if (hasModal) {
        openModal(targetCard);
      } else {
        highlightCard(targetCard);
      }
    }
  }
});
